<div class="holder">
  <spb-start-text/>
  <div class="iframe-holder">
    <iframe [src]="url()" title="holder"></iframe>
  </div>
</div>
